(function(){
    'use strict';

    angular.module('elogbooks.admin.users', []);
})();
